import { propEq, propOr, whereEq } from 'ramda';

import { optimisticTranslate } from '@i18n';

import {
    MEMBER_INVITATION_STATUSES,
    MEMBER_ROLE_BY_ID,
    MEMBER_ROLE_LABEL_BY_ID,
    MEMBER_ROLES
} from '@framework/constants/enums';

import { MEMBER_STATES } from '@type/members';

// Member roles
export const isMember = whereEq({
    isMeetingOrganiser: false,
    role: MEMBER_ROLES.MEMBER,
    state: MEMBER_STATES.ACTIVE
});
export const isEditor = whereEq({ isMeetingOrganiser: true, state: MEMBER_STATES.ACTIVE });
export const isGroupManager = whereEq({
    isGroupManager: true,
    isMeetingOrganiser: true,
    state: MEMBER_STATES.ACTIVE
});
export const isUserManagementAdmin = whereEq({
    role: MEMBER_ROLES.USER_MANAGEMENT_ADMIN,
    state: MEMBER_STATES.ACTIVE
});
export const isAssistant = whereEq({ role: MEMBER_ROLES.ASSISTANT });
export const isAdmin = whereEq({ role: MEMBER_ROLES.ADMIN, state: MEMBER_STATES.ACTIVE });
export const isContributor = whereEq({
    role: MEMBER_ROLES.CONTRIBUTOR,
    state: MEMBER_STATES.ACTIVE
});
export const isOrganisationUser = whereEq({ isOrganisationUser: true });

// Member states
export const isDraft = whereEq({
    state: MEMBER_STATES.DRAFT,
    invitationStatus: MEMBER_INVITATION_STATUSES.NOT_SENT
});
export const isInvited = whereEq({
    state: MEMBER_STATES.DRAFT,
    invitationStatus: MEMBER_INVITATION_STATUSES.PENDING
});
export const isActive = whereEq({ state: MEMBER_STATES.ACTIVE });
export const isInactive = propEq(MEMBER_STATES.INACTIVE, 'state');

export const getFullName = (user) => {
    return user ? `${propOr('', 'firstName', user)} ${propOr('', 'lastName', user)}` : '';
};

export const describeMemberRole = ({
    role,
    isMeetingOrganiser: memberIsMeetingOrganiser,
    isGroupManager: memberIsGroupManager,
    needsTranslation = true
}) => {
    if (memberIsMeetingOrganiser) {
        if (memberIsGroupManager)
            return needsTranslation ? optimisticTranslate('Group manager') : 'groupmanager';
        return needsTranslation ? optimisticTranslate('Editor') : 'editor';
    }
    return needsTranslation ? MEMBER_ROLE_LABEL_BY_ID()[role] : MEMBER_ROLE_BY_ID[role];
};

export const getInvitationAvatarUrlWithOptionalOrganisationId = (url, orgId) => {
    if (!url || !orgId || url.includes('organisation_id=')) {
        return url;
    }

    const originalUrlHasEndSlash = url.charAt(url.length - 1) === '/';
    const buildUrlWithOrganisationId = (imgUrl) =>
        url.includes('?')
            ? `${imgUrl}&organisation_id=${orgId}`
            : `${imgUrl}?organisation_id=${orgId}`;

    if (originalUrlHasEndSlash) {
        const urlWithoutSlash = url.substr(0, url.length - 1);
        return buildUrlWithOrganisationId(urlWithoutSlash);
    }
    return buildUrlWithOrganisationId(url);
};
